import {
  Box,
  Grid,
  Stack,
  Button,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
} from "../../../Theme";
import { ReactComponent as EditIcon } from "../../../Icons/Edit.svg";
import moment from "moment";

const ReviewAccount = ({
  companyDetails,
  administratorDetails,
  projectDetails,
  setaddblocks,
  handleSubmit,
  loading,
}) => {
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };
  return (
    <>
      <Box
        mt={3}
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 0px 0px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Company Details</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            onClick={() => {
              setaddblocks({
                Company_Details: true,
                Project_Information: false,
                Administrator_Details: false,
                Review_Account: false,
              });
            }}
            variant="outlined"
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Company Name</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.company_name}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Country</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.company_country}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Email Address
            </StyledSecondaryTypography>
            <TypographyDefault>
              {" "}
              {companyDetails?.company_email_address}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contact Number
            </StyledSecondaryTypography>
            <TypographyDefault>
              +{companyDetails?.company_country_code}{" "}
              {companyDetails?.company_contact_number.slice(
                companyDetails?.company_country_code?.length
              )}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Address
            </StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.company_address}
            </TypographyDefault>
          </Grid>
        </Grid>
      </Box>

      <Box
        // mt={3}
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        // borderRadius="8px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            // borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Billing Details</SecondaryTypography>
          </Stack>
          <Button
            // onClick={() => Continue("Personal Details", "")}
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            variant="outlined"
            onClick={() => {
              setaddblocks({
                Company_Details: true,
                Project_Information: false,
                Administrator_Details: false,
                Review_Account: false,
              });
            }}
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contract Terms
            </StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_contract_terms}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Billing Entity
            </StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_entity}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Commence Date</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_commence_date
                ? moment(companyDetails?.billing_commence_date).format(
                    "DD-MM-YYYY"
                  ) // Example: "December 1, 2024"
                : "No date selected"}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>End Date</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_commence_date
                ? moment(companyDetails?.billing_end_date).format("DD-MM-YYYY") // Example: "December 1, 2024"
                : "No date selected"}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_full_name}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Billing Email Address
            </StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_email_address}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />

          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contact Number
            </StyledSecondaryTypography>
            <TypographyDefault>
              +{companyDetails?.billing_country_code}{" "}
              {companyDetails?.billing_contact_number.slice(
                companyDetails?.billing_country_code.length
              )}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Billing Cycle</StyledSecondaryTypography>
            <TypographyDefault>
              {companyDetails?.billing_cycle?.name}
            </TypographyDefault>
          </Grid>
        </Grid>
      </Box>

      <Box
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 0px 0px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Project Information</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            variant="outlined"
            onClick={() => {
              setaddblocks({
                Company_Details: false,
                Project_Information: true,
                Administrator_Details: false,
                Review_Account: false,
              });
            }}
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Project Title</StyledSecondaryTypography>
            <TypographyDefault>
              {projectDetails?.project_title}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Type</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.type?.name}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>No. of Units</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.units}</TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Address</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.address}</TypographyDefault>
          </Grid>

          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Completion Year
            </StyledSecondaryTypography>
            <TypographyDefault>
              {projectDetails?.completion_year}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Tenure</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.tenure}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Country</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.country}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>City</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.city}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Postal Code</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.postal_code}</TypographyDefault>
          </Grid>
        </Grid>
      </Box>

      <Box component="div" boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Contact Details</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            onClick={() => {
              setaddblocks({
                Company_Details: false,
                Project_Information: true,
                Administrator_Details: false,
                Review_Account: false,
              });
            }}
            variant="outlined"
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.full_name}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Position</StyledSecondaryTypography>
            <TypographyDefault>{projectDetails?.position}</TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Email Address</StyledSecondaryTypography>
            <TypographyDefault>
              {" "}
              {projectDetails?.email_address}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contact Number
            </StyledSecondaryTypography>
            <TypographyDefault>
              +{projectDetails?.country_code}{" "}
              {projectDetails?.contact_number?.slice(
                projectDetails?.country_code.length
              )}
            </TypographyDefault>
          </Grid>
        </Grid>
      </Box>
      <Box
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 0px 0px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Administrator Details</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            onClick={() => {
              setaddblocks({
                Company_Details: false,
                Project_Information: false,
                Administrator_Details: true,
                Review_Account: false,
              });
            }}
            variant="outlined"
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
            <TypographyDefault>
              {administratorDetails?.full_name}
            </TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Email Address</StyledSecondaryTypography>
            <TypographyDefault>
              {" "}
              {administratorDetails?.email_address}
            </TypographyDefault>
          </Grid>
        </Grid>
      </Box>
      <Box
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 0px 0px"
      >
        <Stack
          direction="row"
          alignItems="center"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
          }}
        >
          <SecondaryTypography>Onboarded by</SecondaryTypography>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Client Lead</StyledSecondaryTypography>
            <TypographyDefault>Keynes yeo</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Email</StyledSecondaryTypography>
            <TypographyDefault>keynesyeo@loby.tech</TypographyDefault>
          </Grid>
        </Grid>
      </Box>

      <Box
        bgcolor="#FFFFFF"
        sx={{
          border: "1px solid  #E5E7EB",
          borderTop: " 1px solid #F3F4F6",
          boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
          borderRadius: "0px 0px 8px 8px",
        }}
      >
        <Stack
          direction="row"
          py={2}
          px={2}
          justifyContent="end"
          alignItems="center"
          height="60px"
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button
              type="button"
              onClick={handleSubmit}
              sx={{ width: "fit-content" }}
              variant="Standard"
            >
              {loading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default ReviewAccount;
